import React, { useState, useEffect } from 'react'
import { Progress, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { getIcon } from '../../../../assets/getIcon'
import styles from './styles.module.css'

export default function Analysis(props) {
  const {
    style = {},
    status,
    analysisData,
    bufferData = null,
    fileData = null
  } = props
  // const [errData] = useState(0)
  // const [successData] = useState(0)
  const [analysisDatas, setAnalysisDatas] = useState(0)
  const [bufferDatas, setbufferDatas] = useState(bufferData)

  useEffect(() => {
    setAnalysisDatas(analysisData)
  }, [analysisData])

  useEffect(() => {
    setbufferDatas(bufferData)
  }, [bufferData])

  return (
    <div
      style={{ width: '1056px', height: '246px', ...style }}
      className={styles.zhyl_ckd_upload_analysis}
    >
      <p className={styles.zhyl_ckd_upload_analysis_title}>{`${
        status === 'done' ? '计算完成' : '计算状态'
      }`}</p>
      <Progress
        showInfo={false}
        style={{ width: '300px', marginTop: '16px' }}
        percent={analysisDatas.percent}
        strokeColor='#018AD1'
        trailColor='rgba(1,138,209,0.3)'
      />
      <div>
        <div
          style={{ marginTop: '16px' }}
          className={styles.zhyl_ckd_upload_analysis_status}
        >
          <img
            style={{ width: '16px', height: '16px', marginRight: '7px' }}
            src={getIcon('cha2x')}
          />
          <span
            className={styles.zhyl_ckd_upload_analysis_txt}
          >{`${analysisDatas.errorNum}条数据校验失败`}</span>
        </div>
        <div
          style={{ marginTop: '8px' }}
          className={styles.zhyl_ckd_upload_analysis_status}
        >
          <img
            style={{ width: '16px', height: '16px', marginRight: '7px' }}
            src={getIcon('gou2x')}
          />
          <span
            className={styles.zhyl_ckd_upload_analysis_txt}
          >{`${analysisDatas.rowNum}条数据计算成功`}</span>
        </div>
      </div>
      {status === 'done' ? (
        <div className={styles.zhyl_ckd_upload_analysis_bottom_wrap}>
          <Button
            style={{ marginTop: '60px', marginBottom: '8px' }}
            type='primary'
            icon={
              <img
                src={getIcon('Download2x')}
                style={{ width: 20, height: 20, marginRight: 12 }}
              />
            }
            onClick={() => {
              const blob = new Blob([bufferDatas])
              const URL = window.URL || window.webkitURL
              const url = URL.createObjectURL(blob)
              const a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              a.download = `${
                fileData ? fileData.file.name : `${new Date().getTime()}.xlsx`
              }`
              document.body.appendChild(a)
              a.click()
              URL.revokeObjectURL(url)
            }}
          >
            导出结果
          </Button>
          <span className={styles.zhyl_ckd_upload_analysis_bottom_tet1}>
            计算结果将以新增列的方式附在上传文件原有数据列的右侧，
            <span className={styles.zhyl_ckd_upload_analysis_bottom_tet2}>
              数据不全或格式错误则标红显示
            </span>
          </span>
        </div>
      ) : null}
    </div>
  )
}
